import axios from 'axios';
import { toBasicFormData } from '~/src/helpers/formatter';
import { API_ENDPOINT_USER_REQUEST } from '~/src/constants';
import { captureException } from '@sentry/node';

export interface IOmsResponse {
    status: number,
    message: string | undefined | null
}

export async function requestByCallByOms(phone: string, cityId: number | string): Promise<IOmsResponse> {
    try {
        await axios.post('/user/request-by-call-by-oms', toBasicFormData({
            phone,
            cityId,
        }), { baseURL: API_ENDPOINT_USER_REQUEST });
        return {
            status: 1,
            message: undefined,
        };
    } catch (err) {
        captureException(err);
        return {
            status: 0,
            message: err?.response?.data?.message,
        };
    }
}
